import { RESTRICTION_ACCESS } from '~/constants/integrations';
import integrationStore from '~/mobx/integrationStore';

export const branchItemPriceRestriction = (pos_service_id: string | null): RESTRICTION_ACCESS => {
  if (!pos_service_id) return RESTRICTION_ACCESS.ALLOWED;

  return integrationStore.posRestrictions?.globalItemPrices ?? RESTRICTION_ACCESS.ALLOWED;
};

export const branchItemIsStockRestriction = (pos_service_id: string | null): RESTRICTION_ACCESS => {
  if (!pos_service_id) return RESTRICTION_ACCESS.ALLOWED;

  return integrationStore.posRestrictions?.globalItemStock ?? RESTRICTION_ACCESS.ALLOWED;
};

export const branchItemAvailabilityRestriction = (pos_service_id: string | null): RESTRICTION_ACCESS => {
  if (!pos_service_id) return RESTRICTION_ACCESS.ALLOWED;

  return integrationStore.posRestrictions?.globalItemAvailability ?? RESTRICTION_ACCESS.ALLOWED;
};

export const branchOptionPriceRestriction = (pos_service_id: string | null): RESTRICTION_ACCESS => {
  if (!pos_service_id) return RESTRICTION_ACCESS.ALLOWED;

  return integrationStore.posRestrictions?.optionGlobalPrice ?? RESTRICTION_ACCESS.ALLOWED;
};
export const branchOptionAvailabilityRestriction = (pos_service_id: string | null): RESTRICTION_ACCESS => {
  if (!pos_service_id) return RESTRICTION_ACCESS.ALLOWED;

  return integrationStore.posRestrictions?.itemOptionGlobalAvailability ?? RESTRICTION_ACCESS.ALLOWED;
};
